import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Films from "./pages/Films";
import Network from "./pages/Network";
import SignIn from "./pages/SignIn";
import About from "./pages/About";
import SubmitFilm from "./pages/SubmitFilm";
import JoinNetwork from "./pages/JoinNetwork";
import Contact from "./pages/Contact";
import Festival from "./pages/Festival";
import Productions from "./pages/Productions";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Admin from "./pages/Admin";
import Membership from "./pages/Membership";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import CookieNotice from "./components/CookieNotice";

function Shell() {
  const location = useLocation();
  // Synchronous hash check — handle auth callback BEFORE protected routes evaluate.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="app-shell flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/films" element={<Films />} />
          <Route path="/films/submit" element={<SubmitFilm />} />
          <Route path="/festival" element={<Festival />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/productions" element={<Productions />} />
          <Route path="/network/join" element={<JoinNetwork />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/about" element={<About />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/network"
            element={
              <ProtectedRoute>
                <Network />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      <Footer />
      <CookieNotice />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
